'use client';
import routes from '@/routes/router';
import { motion } from 'motion/react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import OldVersionToggler from '../OldVersionToggler';

const Footer = ({ isMobile, isTablet }) => {
  const [paths, setPath] = useState(routes);
  const [isClient, setIsClient] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    setIsClient(true);
    setPath((previousPaths) => {
      const newValue = previousPaths.map((path) => {
        if (pathname === path.path) {
          return { ...path, active: true };
        }
        return { ...path, active: false };
      });
      return newValue;
    });
  }, [pathname]);

  return (
    <footer
      className="page-footer
     mt-2  mt-lg-auto bg-body-tertiary"
    >
      <div className="row g-0">
        {isTablet && isClient && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="radio col-12 col-lg-5 d-flex justify-content-center align-items-center  "
          >
            <iframe
              src="https://mixlr.com/users/8847859/embed"
              width="100%"
              scrolling="no"
              frameBorder="no"
              marginHeight="0"
              marginWidth="0"
            ></iframe>
          </motion.div>
        )}
        <div className="links col-12 col-lg-7 ">
          <div className="row g-0 justify-content-center justify-content-md-start align-items-center">
            {!isMobile && isClient && (
              <motion.div
                initial={{ opacity: 0, width: 0 }}
                animate={{ opacity: 1, width: 'auto' }}
                exit={{ opacity: 0, width: 0 }}
                className="nation-logo  ps-4"
                // justify-content-start col-12 col-sm-2 col-md-4 d-flex"
              >
                <a href="https://wendake.ca/" target={'_blank'}>
                  <img src="/images/logo_wendake_nobg.png" alt="logo de la nation Huronne Wendat" />
                </a>
              </motion.div>
            )}
            <div className="legal-documents col-12 col-sm-10 col-md-8 p-3 d-flex flex-column flex-lg-row justify-content-between">
              {paths.map((route) => {
                if (route.footerLegals) {
                  return (
                    <Link
                      href={route.path}
                      className={`nav-link ${route.active ? 'active' : ''}`}
                      key={route.path}
                    >
                      {route.name} {isMobile}
                    </Link>
                  );
                }
              })}
              <OldVersionToggler />
            </div>
            {isMobile && isClient && (
              <motion.div
                initial={{ opacity: 0, width: 0 }}
                animate={{ opacity: 1, width: 'auto' }}
                exit={{ opacity: 0, width: 0 }}
                className="nation-logo col-12 col-sm-2 d-flex justify-content-center"
              >
                <a href="https://wendake.ca/" target={'_blank'}>
                  <img src="/images/logo_wendake_nobg.png" alt="logo de la nation Huronne Wendat" />
                </a>
              </motion.div>
            )}
          </div>
          <div className={'row g-0 m-2'}>
            <small className={'col-12'}>
              <span>© 2024 - COMITÉ DE LA RADIO COMMUNAUTAIRE HURONNE-WYANDOT INC. - &nbsp;</span>
              <span>Tous droits réservés&nbsp;</span>
              <span>
                / Firme &nbsp;:
                <a href="https://bzinc.ca/" target="_blank">
                  BZ&nbsp;inc.
                </a>
              </span>
            </small>
          </div>
        </div>
        {!isMobile && !isTablet && isClient && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0, width: 0 }}
            className="radio col-12 col-lg-5  d-flex justify-content-center align-items-center "
          >
            <iframe
              src="https://mixlr.com/users/8847859/embed"
              width="100%"
              scrolling="no"
              frameBorder="no"
              marginHeight="0"
              marginWidth="0"
            ></iframe>
          </motion.div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
